import React from 'react'
import { Dimmer, Grid, Loader } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'

import "react-datepicker/dist/react-datepicker.css";

@inject('SaleStore')
@observer
export default class SaleList extends React.Component {
    render(){
        return(<Grid>
            <Dimmer page={true} active={this.props.SaleStore.isLoading} inverted><Loader /></Dimmer>
        </Grid>)
    }
}